/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-04-11 14:12:48
 * @LastEditTime: 2025-04-25 10:11:02
 */
import request from '@/utils/request';

// 申请创建售后
export const applyAfterSales = (data:any) =>
  request({
    url: 'orderCenter/apply/add.json',
    method: 'post',
    data,
  });
// 获取售后原因列表
export const getReasonList = () =>
  request({
    url: 'orderCenter/apply/reason/list.json',
  });
// 获取售后申请列表
export const afterSalesList = (data:any) =>
  request({
    url: 'orderCenter/apply/list.json',
    method: 'post',
    data,
  });
// 取消售后
export const cancelAfterSales = (data:any) =>
  request({
    url: 'orderCenter/apply/cancel.json',
    method: 'post',
    data,
  });
// 删除售后申请
export const deleteAfterSales = (id: string) =>
  request({
    url: `orderCenter/apply/delete.json/${id}`,
    method: 'post'
  })
// 获取售后详情
export const afterSalesDetail = (id: string) =>
  request({
    url: `orderCenter/apply/getInfo.json/${id}`,
  })
// 删除上传的图片
export const deleteUploadImg = (data: any) =>
  request({
    url: `product/file/remove`,
    method: 'post',
    data
  })